import { RunFieldsConfiguration } from "../../field-type";


export const adyenFileRunFieldsConfiguration: RunFieldsConfiguration = {

    runCursor: {
        visible: false
    },
    file: {
        visible: true,
        mimeType: "text/csv,application/vnd.ms-excel"
    }

}